import { DROM_COMMUNES, DEPARTMENT_LABELS } from '../data/drom-data';

export function getLocationLabel(location, department) {
  if (!location) return '';
  
  // Try to find in DROM communes
  if (department && DROM_COMMUNES[department]) {
    const commune = DROM_COMMUNES[department].find(c => c.value === location);
    const deptLabel = DEPARTMENT_LABELS[department] || department;
    if (commune) return `${commune.label}, ${deptLabel}`;
  }
  
  // Search all departments if no department specified
  for (const [dept, communes] of Object.entries(DROM_COMMUNES)) {
    const found = communes.find(c => c.value === location);
    if (found) return `${found.label}, ${DEPARTMENT_LABELS[dept]}`;
  }
  
  // Fallback: format the value as-is
  return location.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

export function getDepartmentLabel(department) {
  return DEPARTMENT_LABELS[department] || department || '';
}
